import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
const FormErrorMessage = ({ message }) => {
  const errorMessageRef = useRef(null);

  useEffect(() => {
    errorMessageRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, [errorMessageRef]);

  return <div ref={errorMessageRef}>{message}</div>;
};

FormErrorMessage.propTypes = {
  message: PropTypes.string.isRequired
};

export default FormErrorMessage;
